const STORAGE_KEY = 'demohub_realestate';

export const PROPERTY_TYPES = ['All', 'House', 'Apartment', 'Condo', 'Villa', 'Townhouse', 'Penthouse'];
export const SORT_OPTIONS = [
  { id: 'featured', label: 'Featured' },
  { id: 'price-low', label: 'Price: Low to High' },
  { id: 'price-high', label: 'Price: High to Low' },
  { id: 'newest', label: 'Newest' },
  { id: 'sqft', label: 'Largest' },
];

export const AMENITIES_LIST = [
  'Swimming Pool', 'Gym', 'Parking', 'Garden', 'Security', 'Elevator',
  'Balcony', 'Fireplace', 'Smart Home', 'Pet Friendly', 'Laundry', 'Storage',
];

export const AGENTS = [
  { id: 'a1', name: 'Michael Roberts', avatar: '👨‍💼', phone: '+1 (555) 123-4567', email: 'michael@luxhomes.com', rating: 4.9, deals: 234, specialty: 'Luxury Homes' },
  { id: 'a2', name: 'Jennifer Liu', avatar: '👩‍💼', phone: '+1 (555) 234-5678', email: 'jennifer@luxhomes.com', rating: 4.8, deals: 189, specialty: 'Waterfront Properties' },
  { id: 'a3', name: 'David Anderson', avatar: '🧑‍💼', phone: '+1 (555) 345-6789', email: 'david@luxhomes.com', rating: 4.7, deals: 156, specialty: 'Commercial Real Estate' },
  { id: 'a4', name: 'Sarah Mitchell', avatar: '👩‍🦰', phone: '+1 (555) 456-7890', email: 'sarah@luxhomes.com', rating: 4.9, deals: 312, specialty: 'Family Homes' },
];

export const LOCATIONS = [
  'Manhattan, NY', 'Beverly Hills, CA', 'Miami Beach, FL', 'Brooklyn, NY',
  'San Francisco, CA', 'Austin, TX', 'Seattle, WA', 'Chicago, IL',
  'Malibu, CA', 'Scottsdale, AZ', 'Nashville, TN', 'Denver, CO',
];

const IMAGES_MAP = {
  House: ['🏡', '🏠', '🏘️'],
  Apartment: ['🏢', '🏬', '🏗️'],
  Condo: ['🏙️', '🌆', '🏢'],
  Villa: ['🏰', '🏖️', '🌴'],
  Townhouse: ['🏘️', '🏠', '🏡'],
  Penthouse: ['🌃', '🏙️', '✨'],
};

const DESCRIPTIONS = [
  'Stunning modern residence with floor-to-ceiling windows, open concept living, and premium finishes throughout. Chef\'s kitchen with marble countertops and top-of-the-line appliances.',
  'Beautifully renovated home featuring hardwood floors, spacious rooms, and a sun-drenched living area. Private backyard perfect for entertaining.',
  'Luxury living at its finest. This property boasts panoramic views, designer interiors, and world-class amenities. Smart home technology throughout.',
  'Elegant and sophisticated, this residence offers a seamless blend of comfort and style. Gourmet kitchen, spa-like bathrooms, and generous closet space.',
  'Contemporary masterpiece with clean lines and an abundance of natural light. Open floor plan ideal for modern living and entertaining.',
  'Charming property in a prime location, steps from restaurants, shops, and parks. Recently updated with modern fixtures and finishes.',
];

function seededRandom(seed) {
  let s = seed;
  return function () {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export const PROPERTIES = Array.from({ length: 24 }, (_, i) => {
  const rand = seededRandom(i * 137 + 42);
  const types = PROPERTY_TYPES.filter((t) => t !== 'All');
  const type = types[Math.floor(rand() * types.length)];
  const beds = type === 'Apartment' || type === 'Condo' ? Math.floor(1 + rand() * 3) : Math.floor(2 + rand() * 5);
  const baths = Math.max(1, Math.floor(beds * 0.7 + rand()));
  const sqft = Math.round((800 + rand() * 4000 + beds * 400) / 100) * 100;
  const price = Math.round((200000 + rand() * 2800000 + sqft * 150) / 1000) * 1000;
  const yearBuilt = Math.floor(1990 + rand() * 35);
  const location = LOCATIONS[Math.floor(rand() * LOCATIONS.length)];
  const agent = AGENTS[Math.floor(rand() * AGENTS.length)];
  const images = IMAGES_MAP[type] || ['🏠'];
  const amenityCount = Math.floor(3 + rand() * 6);
  const shuffled = [...AMENITIES_LIST].sort(() => rand() - 0.5);
  const amenities = shuffled.slice(0, amenityCount);
  const featured = rand() > 0.7;
  const isNew = rand() > 0.75;
  const priceReduced = !isNew && rand() > 0.8;
  const originalPrice = priceReduced ? Math.round(price * (1.05 + rand() * 0.15) / 1000) * 1000 : null;

  return {
    id: `prop-${i + 1}`,
    title: `${type === 'Penthouse' ? 'Luxury ' : ''}${beds}-Bed ${type} in ${location.split(',')[0]}`,
    type,
    price,
    originalPrice,
    beds,
    baths,
    sqft,
    location,
    yearBuilt,
    description: DESCRIPTIONS[Math.floor(rand() * DESCRIPTIONS.length)],
    images,
    amenities,
    agent,
    featured,
    isNew,
    priceReduced,
    garage: rand() > 0.4 ? Math.floor(1 + rand() * 3) : 0,
    lot: type === 'House' || type === 'Villa' ? (sqft * (1.5 + rand() * 3)).toFixed(0) : null,
    hoa: type !== 'House' && type !== 'Villa' ? Math.round(200 + rand() * 800) : null,
    rating: (4 + rand()).toFixed(1),
    views: Math.floor(100 + rand() * 2000),
    daysOnMarket: Math.floor(1 + rand() * 60),
    createdAt: Date.now() - Math.floor(rand() * 60) * 86400000,
  };
});

export function loadFavorites() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) { /* ignore */ }
  return [];
}

export function saveFavorites(favs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favs));
  } catch (e) { /* ignore */ }
}

export function formatPrice(price) {
  if (price >= 1000000) return `$${(price / 1000000).toFixed(1)}M`;
  return `$${(price / 1000).toFixed(0)}K`;
}

export function formatNumber(num) {
  return num.toLocaleString();
}

export function calculateMortgage(price, downPct, rate, years) {
  const principal = price * (1 - downPct / 100);
  const monthlyRate = rate / 100 / 12;
  const numPayments = years * 12;
  if (monthlyRate === 0) return Math.round(principal / numPayments);
  const payment = principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments)) / (Math.pow(1 + monthlyRate, numPayments) - 1);
  return Math.round(payment);
}
